export const REDUX_SET = '/redux/container/TurnoverReturnVehicle/set';
export const REDUX_RESET = '/redux/container/TurnoverReturnVehicle/reset';
